import { render, staticRenderFns } from "./WaveContact.vue?vue&type=template&id=2fa9c7cf&"
import script from "./WaveContact.vue?vue&type=script&lang=js&"
export * from "./WaveContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports